// removed by extract-text-webpack-plugin
module.exports = {"box-list":"_1GpjLCrDP _2l0xl0HVf"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/box-list/box-list.css
 ** module id = 2085
 ** module chunks = 0
 **/